import React, { useContext } from "react"
import PropTypes from "prop-types"

import useStyles from "./ModalImageCorsStyles"
import ModalImage from "./ModalImage"
import { AuthContext } from "../../context/Auth/AuthContext"

const ModalImageCors = ({ message, imageUrl, sticker }) => {
  const { user } = useContext(AuthContext)

  const sendBy = message?.fromMe
    ? message?.usuarioId === user?.id
      ? "Você"
      : message.usuario?.name || message.ticket?.user?.name
    : message?.contact?.name
  const classes = useStyles()

  return (
    <ModalImage
      className={sticker ? classes.stickerMedia : classes.messageMedia}
      smallSrcSet={imageUrl}
      small={imageUrl}
      medium={imageUrl}
      large={imageUrl}
      alt={sendBy}
    />
  )
}

ModalImageCors.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  sticker: PropTypes.bool,
}

export default ModalImageCors
